module.exports = __webpack_public_path__ + "img/eu-ios.2cb7dee1.png";